module.exports = __webpack_public_path__ + "img/ic／7.9778c16d.png";